module.exports = __webpack_public_path__ + "static/img/041006.64b5ed34.png";